import React from "react";

import checkmarkIcon from "../../images/checkmark.svg?url";

type BuildCardProps = {
  imageSrc1: string;
  imageSrc2: string;
  imageSrc3: string;
  title: string;
  features: string[];
  buttonText: string;
  buttonLink: string;
  disclaimer: string;
  disclaimerReadMoreUrl?: string;
  disclaimerReadMoreOnclick?: () => void;
};

export const BuildCard: React.FC<BuildCardProps> = ({
  imageSrc1,
  imageSrc2,
  imageSrc3,
  title,
  features,
  buttonText,
  buttonLink,
  disclaimer,
  disclaimerReadMoreUrl,
  disclaimerReadMoreOnclick,
}) => {
  const handleReadMoreClick = () => {
    if (disclaimerReadMoreOnclick) {
      disclaimerReadMoreOnclick();
    } else if (disclaimerReadMoreUrl) {
      window.open(disclaimerReadMoreUrl, "_blank");
    }
  };

  return (
    <div className="bg-white rounded-[20px] border border-grey-lighter py-7 px-5 flex flex-col items-center h-full">
      {!!title && <div className="mb-[30px] text-primary-dark">{title}</div>}
      <div className="flex flex-col justify-between h-full">
        <div>
          <div className="flex flex-col w-full mb-4 py-8 px-6 bg-grey-light rounded-lg">
            <div className="relative h-20 mb-[-20px]">
              <img
                src={imageSrc1}
                alt="image 1"
                className="w-full h-full object-contain"
                width={241}
                height={64}
              />
            </div>
            <div className="relative h-20 z-10 mb-4 mt-4">
              <img
                src={imageSrc2}
                alt="image 2"
                className="w-full h-full object-contain transform scale-110"
                width={270}
                height={64}
              />
            </div>
            <div className="relative h-20 mt-[-20px]">
              <img
                src={imageSrc3}
                alt="image 3"
                className="w-full h-full object-contain"
                width={241}
                height={64}
              />
            </div>
          </div>
          <div className="px-6">
            <ul className="mb-4 min-h-[120px]">
              {features.map((feature, index) => (
                <li
                  key={index}
                  className="grid grid-cols-12 items-start mb-2 text-gray-700"
                >
                  <span className="mr-2 col-span-1 text-green-500">
                    <img src={checkmarkIcon} alt="checkmark" />
                  </span>
                  <span className="col-span-11 mt-1 text-sm md:text-md">
                    {feature}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col w-full">
          <a
            href={buttonLink}
            target="_blank"
            className="py-2 px-5 h-fit pointer text-sm rounded-[8px] text-center text-white text-md bg-success"
          >
            {buttonText}
          </a>
          <p className="text-xs text-[#A2A2A2] max-w-[300px] mt-2 text-center mx-auto">
            {disclaimer}&nbsp;
            {(!!disclaimerReadMoreUrl || !!disclaimerReadMoreOnclick) && (
              <a
                className="underline cursor-pointer"
                onClick={handleReadMoreClick}
              >
                Read more
              </a>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};
